import React from 'react';
import FlashOnRoundedIcon from '@material-ui/icons/FlashOnRounded';
import strings from 'strings';
import { When } from 'UI/components/atoms';
import SidebarActionButton from 'UI/components/molecules/SidebarActionButton';
import { addMenu } from 'UI/constants/dimensions';

import { CandidateQuickEntryDrawer } from './components/CandidateQuickEntryDrawer';
import { JobOrderQuickEntryDrawer } from './components/JobOrderQuickEntryDrawer';
import { QuickEntrySelectionDialog } from './components/QuickEntrySelectionDialog';
import { QUICK_ENTRY_SELECTION_KEYS } from './constants';
import { useQuickEntry } from './hooks';
import { useStyles } from './QuickEntry.styled';

const COPIES = strings.inventory.quickEntry;

export const QuickEntry = () => {
  const classes = useStyles();
  const { activeEntity, closeDialog, closeDrawer, isDialogOpen, openDialog, selectEntity } =
    useQuickEntry();

  return (
    <>
      <SidebarActionButton
        className={classes.triggerButton}
        icon={FlashOnRoundedIcon}
        iconSize={addMenu.addButton.iconSize}
        onClick={openDialog}
        text={COPIES.actionButton}
      />

      <When condition={isDialogOpen}>
        <QuickEntrySelectionDialog
          onClose={closeDialog}
          onSelect={selectEntity}
          open={isDialogOpen}
        />
      </When>

      <When condition={activeEntity === QUICK_ENTRY_SELECTION_KEYS.candidate}>
        <CandidateQuickEntryDrawer onClose={closeDrawer} />
      </When>

      <When condition={activeEntity === QUICK_ENTRY_SELECTION_KEYS.jobOrder}>
        <JobOrderQuickEntryDrawer onClose={closeDrawer} />
      </When>
    </>
  );
};
